"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIntegrated = exports.getIntegration = exports.INTEGRATION_TO_OCPI_DISPLAY_NAME = exports.INTEGRATION_TO_OCPI_INFO_LOOKUP = exports.credTokenToPartyId = exports.buildOcpiEvseId = exports.formatOcpiEvseId = exports.chargerPortIdToEVSEUID = void 0;
const ee_nestjs_interfaces_1 = require("ee-nestjs-interfaces");
/**
 * This converts from a port ID and charger ID to an OCPI ID.
 *
 * @param chargerId The charger ID.
 * @param portId The port ID. If port ID 0 is used, this returns an identifier for all ports.
 * @returns The OCPI UID of the charger/port combo.
 */
function chargerPortIdToEVSEUID(chargerId, portId) {
    return `${chargerId}${portId == 0 ? "" : String.fromCharCode("A".charCodeAt(0) + portId)}`;
}
exports.chargerPortIdToEVSEUID = chargerPortIdToEVSEUID;
/**
 * Formats the full OCPI evse_id sent to roaming partners from a site's country code
 * and an EVSE UID (see chargerPortIdToEVSEUID).
 *
 * @param country The two-letter country code of the site.
 * @param evseUid The OCPI UID of the charger/port combo.
 * @returns The full OCPI evse_id, e.g. "US*ECE*E0001234B".
 */
function formatOcpiEvseId(country, evseUid) {
    return `${country}*${ee_nestjs_interfaces_1.ELECTRIC_ERA_PARTY_ID}*E${evseUid.padStart(8, "0")}`;
}
exports.formatOcpiEvseId = formatOcpiEvseId;
/**
 * Builds the full OCPI evse_id sent to roaming partners directly from a charger/port combo,
 * combining chargerPortIdToEVSEUID and formatOcpiEvseId.
 *
 * @param country The two-letter country code of the site.
 * @param chargerId The charger ID.
 * @param portId The port ID. If port ID 0 is used, this returns an identifier for all ports.
 * @returns The full OCPI evse_id for the given charger/port combo.
 */
function buildOcpiEvseId(country, chargerId, portId) {
    return formatOcpiEvseId(country, chargerPortIdToEVSEUID(chargerId, portId));
}
exports.buildOcpiEvseId = buildOcpiEvseId;
/**
 * We don't always know if the eMSP will be the sender or the reciever for token A.
 * @param token The credentials token to find eMSP from
 * @returns The name of the eMSP that the token is associated with
 */
function credTokenToPartyId(token) {
    if (token.TOKEN_A_OWNER == ee_nestjs_interfaces_1.ELECTRIC_ERA_PARTY_ID) {
        return token.TOKEN_A_RECIPIENT;
    }
    else {
        return token.TOKEN_A_OWNER;
    }
}
exports.credTokenToPartyId = credTokenToPartyId;
exports.INTEGRATION_TO_OCPI_INFO_LOOKUP = new Map([
    [ee_nestjs_interfaces_1.Integrations.HUBJECT, ["DE", "ICE"]],
    [ee_nestjs_interfaces_1.Integrations.WEX, ["US", "WEX"]],
    [ee_nestjs_interfaces_1.Integrations.MONTA, ["DK", "MON"]],
    [ee_nestjs_interfaces_1.Integrations.OCTOPUS, ["GB", "OCT"]],
]);
exports.INTEGRATION_TO_OCPI_DISPLAY_NAME = new Map([
    // These names were determined by Customer Success.
    [ee_nestjs_interfaces_1.Integrations.HUBJECT, "roaming:hubject"],
    [ee_nestjs_interfaces_1.Integrations.WEX, "fleet:WEX"],
    [ee_nestjs_interfaces_1.Integrations.MONTA, "roaming:monta"],
    [ee_nestjs_interfaces_1.Integrations.OCTOPUS, "roaming:octopus"],
]);
/**
 * Typescript's Map compares arrays by reference so we can't make a reverse lookup with a tuple.
 */
function getIntegration(token) {
    for (const [integrator, [country, party],] of exports.INTEGRATION_TO_OCPI_INFO_LOOKUP) {
        if (country === token.countryCode && party === credTokenToPartyId(token))
            return integrator;
    }
    return undefined;
}
exports.getIntegration = getIntegration;
/**
 * Return whether an organization is integrated with an OCPI token
 */
function isIntegrated(token, org) {
    if (!org.integrations || org.integrations.length == 0)
        return false;
    return org.integrations.some((integration) => {
        const [country, party] = exports.INTEGRATION_TO_OCPI_INFO_LOOKUP.get(integration);
        return country === token.countryCode && party === credTokenToPartyId(token);
    });
}
exports.isIntegrated = isIntegrated;
